import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../contexts/AuthContext";
import { normaliseStatus } from "../utils/subscriptionState";

/**
 * The household's subscription status, read once when a screen opens
 * (V19.03). null until it arrives or if it cannot be read - and every screen
 * that uses it treats null as "say nothing", never as "locked".
 */
export function useSubscriptionStatus(enabled = true) {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    axios.get(`${API}/subscription/status`)
      .then((res) => { if (alive) setStatus(normaliseStatus(res.data)); })
      .catch(() => { /* say nothing */ });
    return () => { alive = false; };
  }, [enabled]);
  return status;
}

export default useSubscriptionStatus;
